import { useTranslation } from "react-i18next";
import { Inbox } from "lucide-react";
import Spinner from "../../../../../../../../../../components/shared/Spinner";
import Item from "./Item";
import { useScheduleContext } from "../../../../../../../hooks/context/useScheduleContext";

function Shifts({ close }: any) {
    const { t } = useTranslation();
    const { loadingMoreModalEvents, moreModalEvents, moreModalTotalItems } = useScheduleContext();

    return (
        <div className="tw-h-full tw-overflow-auto">
            {loadingMoreModalEvents ? (
                <div className="tw-w-full tw-h-full tw-min-h-60 tw-flex tw-items-center tw-justify-center">
                    <Spinner className="tw-size-8 tw-text-primary" />
                </div>
            ) : moreModalTotalItems === 0 ? (
                <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-neutral-600 tw-py-7 tw-border tw-rounded-sm">
                    <Inbox />
                    {t("no-data")}
                </div>
            ) : moreModalEvents.map((shift: any) =>
                <Item
                    key={shift.id}
                    shift={shift}
                    close={close}
                />
            )}
        </div>
    );
}

export default Shifts;
